/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InactiveCleanupCandidateDTOReasonEnum = {
    DetailPageRemoved: 'DETAIL_PAGE_REMOVED',
    PricingIssue: 'PRICING_ISSUE',
    OutOfStock: 'OUT_OF_STOCK',
    GpsrMissing: 'GPSR_MISSING',
    ApprovalRequired: 'APPROVAL_REQUIRED',
    Unknown: 'UNKNOWN'
};
/**
 * Check if a given object implements the InactiveCleanupCandidateDTO interface.
 */
export function instanceOfInactiveCleanupCandidateDTO(value) {
    return true;
}
export function InactiveCleanupCandidateDTOFromJSON(json) {
    return InactiveCleanupCandidateDTOFromJSONTyped(json, false);
}
export function InactiveCleanupCandidateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'inventoryId': json['inventoryId'] == null ? undefined : json['inventoryId'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'title': json['title'] == null ? undefined : json['title'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'sellingPrice': json['sellingPrice'] == null ? undefined : json['sellingPrice'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'inactiveSince': json['inactiveSince'] == null ? undefined : (new Date(json['inactiveSince'])),
        'inactiveDays': json['inactiveDays'] == null ? undefined : json['inactiveDays'],
        'reasonAt': json['reasonAt'] == null ? undefined : (new Date(json['reasonAt'])),
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'sourceAvailability': json['sourceAvailability'] == null ? undefined : json['sourceAvailability'],
    };
}
export function InactiveCleanupCandidateDTOToJSON(json) {
    return InactiveCleanupCandidateDTOToJSONTyped(json, false);
}
export function InactiveCleanupCandidateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'inventoryId': value['inventoryId'],
        'asin': value['asin'],
        'sku': value['sku'],
        'title': value['title'],
        'quantity': value['quantity'],
        'sellingPrice': value['sellingPrice'],
        'reason': value['reason'],
        'inactiveSince': value['inactiveSince'] == null ? undefined : ((value['inactiveSince']).toISOString()),
        'inactiveDays': value['inactiveDays'],
        'reasonAt': value['reasonAt'] == null ? undefined : ((value['reasonAt']).toISOString()),
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'sourceAvailability': value['sourceAvailability'],
    };
}
